const NBSP = " ";

/**
 * Keeps Swedish number groups (and a trailing "kr") together so a value like
 * "500 000 - 15 000 000 kr" never breaks mid-number on narrow screens.
 * Spaces inside a number become non-breaking; the only remaining wrap point is
 * the range separator (" - "), so the value wraps cleanly as
 * "500 000 -" / "15 000 000 kr" instead of "15 000" / "000 kr".
 */
export const protectNumberGroups = (value: string): string =>
  value
    .replace(/(\d)\s(?=\d)/g, `$1${NBSP}`)
    .replace(/(\d)\s(kr|kr\.|SEK)\b/gi, `$1${NBSP}$2`);
